
















































































import Vue, { PropType } from 'vue';
import { domToPng } from 'modern-screenshot';
import { shortTimeAgo, dateMonthYearFormat } from '@/helpers/date-utils';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { DISCOUNT_TYPE, OFFER_TYPE } from '@/store/shared';
import { MD5 } from 'crypto-js';
import { ISession } from '@/store/types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'FeedbackShare',
  mixins: [CopyToClipboard],
  props: {
    session: {
      type: Object as PropType<ISession>,
    },
  },
  data() {
    return {
      showCkBranding: true,
      downloadingImage: false,
      shortTimeAgo,
      dateMonthYearFormat,
    };
  },
  computed: {
    ...mapGetters(['confidential']),
  },
  methods: {
    async downloadImage() {
      this.downloadingImage = true;
      const element = document.getElementById('testimonial') as HTMLElement;
      await domToPng(element).then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'feedback.png';
        link.href = dataUrl;
        link.click();
      });
      this.downloadingImage = false;
    },
    generateGravatarUrl(email: string) {
      const trimmedEmail = email.trim();
      const lowerCaseEmail = trimmedEmail.toLowerCase();
      const hash = MD5(lowerCaseEmail).toString();
      return `https://www.gravatar.com/avatar/${hash}?s=200&d=retro`;
    },
  },
});
